import { render, staticRenderFns } from "./rateModal.vue?vue&type=template&id=ad057630"
import script from "./rateModal.vue?vue&type=script&lang=js"
export * from "./rateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports